import { LogOut } from 'lucide-react'
import { useNavigate } from 'react-router'

import { PasskeyIcon } from '@/components/shared/auth-icons'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { PATHS } from '@/routes/paths'
import { useAuthStore } from '@/store/useAuthStore'

const readMetadataString = (metadata: Record<string, unknown>, key: string): string | null => {
  const value = metadata[key]
  return typeof value === 'string' && value ? value : null
}

/** ヘッダー右上のアカウントメニュー */
export const AccountMenu = () => {
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.session?.user ?? null)

  if (!user) return null

  const name = readMetadataString(user.user_metadata, 'full_name') ?? readMetadataString(user.user_metadata, 'name')
  const avatarUrl = readMetadataString(user.user_metadata, 'avatar_url')
  const initial = (name ?? user.email ?? '?').charAt(0).toUpperCase()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="アカウント"
        className="flex size-8 items-center justify-center overflow-hidden rounded-full border-none bg-black/30 text-sm font-semibold text-white backdrop-blur active:opacity-70"
      >
        {avatarUrl ? (
          <img src={avatarUrl} alt="" referrerPolicy="no-referrer" className="size-full object-cover" />
        ) : (
          initial
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="font-normal">
          {name && <p className="truncate text-sm font-medium">{name}</p>}
          {user.email && <p className="truncate text-xs text-muted-foreground">{user.email}</p>}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => navigate(PATHS.SETTINGS.PASSKEYS)}>
          <PasskeyIcon />
          パスキー
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => navigate(PATHS.SIGN_OUT)}>
          <LogOut />
          サインアウト
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
